import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { toDisposable } from '../../../base/common/lifecycle.js';
import { score } from './languageSelector.js';
import { shouldSynchronizeModel } from '../services/modelService.js';

function isExclusive(selector) {
  if (typeof selector === 'string') {
    return false;
  } else if (Array.isArray(selector)) {
    return selector.every(isExclusive);
  } else {
    return !!selector.exclusive;
  }
}

export var LanguageFeatureRegistry = /*#__PURE__*/function () {
  function LanguageFeatureRegistry() {
    _classCallCheck(this, LanguageFeatureRegistry);

    this._clock = 0;
    this._entries = [];
    this._onDidChange = new Emitter();
  }

  _createClass(LanguageFeatureRegistry, [{
    key: "onDidChange",
    get: function get() {
      return this._onDidChange.event;
    }
  }, {
    key: "register",
    value: function register(selector, provider) {
      var _this = this;

      var entry = {
        selector: selector,
        provider: provider,
        _score: -1,
        _time: this._clock++
      };

      this._entries.push(entry);

      this._lastCandidate = undefined;

      this._onDidChange.fire(this._entries.length);

      return toDisposable(function () {
        if (entry) {
          var idx = _this._entries.indexOf(entry);

          if (idx >= 0) {
            _this._entries.splice(idx, 1);

            _this._lastCandidate = undefined;

            _this._onDidChange.fire(_this._entries.length);

            entry = undefined;
          }
        }
      });
    }
  }, {
    key: "has",
    value: function has(model) {
      return this.all(model).length > 0;
    }
  }, {
    key: "all",
    value: function all(model) {
      if (!model) {
        return [];
      }

      this._updateScores(model);

      var result = []; // from registry

      var _iterator = _createForOfIteratorHelper(this._entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;

          if (entry._score > 0) {
            result.push(entry.provider);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "ordered",
    value: function ordered(model) {
      var result = [];

      this._orderedForEach(model, function (entry) {
        return result.push(entry.provider);
      });

      return result;
    }
  }, {
    key: "orderedGroups",
    value: function orderedGroups(model) {
      var result = [];
      var lastBucket;
      var lastBucketScore;

      this._orderedForEach(model, function (entry) {
        if (lastBucket && lastBucketScore === entry._score) {
          lastBucket.push(entry.provider);
        } else {
          lastBucketScore = entry._score;
          lastBucket = [entry.provider];
          result.push(lastBucket);
        }
      });

      return result;
    }
  }, {
    key: "_orderedForEach",
    value: function _orderedForEach(model, callback) {
      if (!model) {
        return;
      }

      this._updateScores(model);

      var _iterator2 = _createForOfIteratorHelper(this._entries),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;

          if (entry._score > 0) {
            callback(entry);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_updateScores",
    value: function _updateScores(model) {
      var candidate = {
        uri: model.uri.toString(),
        language: model.getLanguageIdentifier().language
      };

      if (this._lastCandidate && this._lastCandidate.language === candidate.language && this._lastCandidate.uri === candidate.uri) {
        // nothing has changed
        return;
      }

      this._lastCandidate = candidate;

      var _iterator3 = _createForOfIteratorHelper(this._entries),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var entry = _step3.value;
          entry._score = score(entry.selector, model.uri, model.getLanguageIdentifier().language, shouldSynchronizeModel(model));

          if (isExclusive(entry.selector) && entry._score > 0) {
            // support for one exclusive selector that overwrites
            // any other selector
            var _iterator4 = _createForOfIteratorHelper(this._entries),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _entry = _step4.value;
                _entry._score = 0;
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }

            entry._score = 1000;
            break;
          }
        } // needs sorting

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._entries.sort(LanguageFeatureRegistry._compareByScoreAndTime);
    }
  }], [{
    key: "_compareByScoreAndTime",
    value: function _compareByScoreAndTime(a, b) {
      if (a._score < b._score) {
        return 1;
      } else if (a._score > b._score) {
        return -1;
      } else if (a._time < b._time) {
        return 1;
      } else if (a._time > b._time) {
        return -1;
      } else {
        return 0;
      }
    }
  }]);

  return LanguageFeatureRegistry;
}();